<template>
  <div :class="$style.Container">
    <span
      v-for="(protocol, i) in protocols"
      :key="protocol.title"
      :class="$style.Container"
      @click="handleOpenPDFModal(protocol)"
    >
      {{ i !== 0 ? '及' : '' }}
      <span>{{ protocol.title }}</span>
    </span>
  </div>
</template>

<script lang="ts" setup>
  import { openPDFModal } from '@lingtu/components';
  import { computed } from 'vue';

  const props = defineProps({
    isActiveVipTab: {
      type: Boolean,
      default: false,
    },
  });
  const protocols = computed(() => {
    if (props.isActiveVipTab) {
      return [
        {
          title: '支付协议',
          url: 'https://static.lingvisions.com/public/6106345b6c05494c88d3039e58d5fa7e.pdf',
        },
        {
          title: '会员服务协议',
          url: 'https://static.lingvisions.com/public/894e33a18da2451ab992ce961408ac9a.pdf',
        },
      ];
    }
    return [
      {
        title: '支付协议',
        url: 'https://static.lingvisions.com/public/6106345b6c05494c88d3039e58d5fa7e.pdf',
      },
    ];
  });
  function handleOpenPDFModal(protocol) {
    openPDFModal({
      src: protocol.url,
      title: protocol.title,
    });
  }
</script>

<style lang="less" module>
  .Container {
    display: flex;
    align-items: center;

    > span {
      > span {
        color: rgba(26, 128, 96, 1) !important;
        cursor: pointer;
        margin: 0 4px;
        font-style: italic;
      }
    }
  }
</style>
